<div class="layout">
  <!-- Header superior -->
  <app-header-top></app-header-top>

  <main class="content">
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </main>
</div>